import WindowResolver from './WindowResolver'


// TODO take it from GQL fragment - added on 5/12/20 by pavelivanov
type Product = {
  id: number
  image: string
  brand: string
  name: string
  amount: number
  url: string // product link
  volume: number
  volumeUnit: string
  category: string
  type: string
  offer?: string
  price: number
  discount: number
  totalPrice: number
  totalPriceWithDiscount: number
  needDiscountOffer: boolean // TODO ask backend how it will work in Recurly - added on 5/12/20 by pavelivanov
}

type Events = {
  'signup': void
  'set CCPA': void
  'user found': {
    user: {
      id: number
      email: string
    }
  }
  'pick product': {
    pickProduct: {
      value: number
      currency: string
      content_ids: number[]
      content_name: string
      content_type: string
    }
  }
  'pageView': {
    user: {
      id: number
      gender: string
      email: string
      subscriptionStatus: SubscriptionStatus
    },
    revenue: number
    cart: any // TODO add Cart to global.d.ts OR take from Cart GraphQL scheme - added on 4/10/20 by pavelivanov
    count: number // cart item count
  }
  'lead page event': {
    OrderId: number
  }
  'ecommerce thank you page': {
    total: number
  }
  'gift card thank you page': {
    total: number
  }
  'subscription thank you page': {
    subscription: {
      id: string
      coupon: string
      couponType: string
      chargeAmount: number
      plan: SubscriptionPlan
      isGift: boolean
    }
  }
  'purchase': {
    revenue: number
  }
  'checkout': {
    checkoutType: (
      'subscription'
      | 'ecommerce'
      | 'ecommerce + subscription'
      | 'gift card'
      | 'gift subscription'
      | 'buy queue'
      | 'toss in'
      )
  }
  'unsubscribe': {
    partner: string
    subscriptionDate: string
  }
}

type TrackArgs<EventParams> = EventParams extends void ? [] : [ EventParams ]
type PushParams = { [key: string]: any }

interface DataLayer {
  track<K extends keyof Events>(event: K, ...args: TrackArgs<Events[K]>): void
  push(params: PushParams): void
}

declare global {
  interface Window {
    dataLayer: {
      push(params: { [key: string]: any }): void
    }
  }
}


/*

 From docs:

 dataLayer.push({ event: 'checkout', type: 'subscription' })
 dataLayer.push({ type: 'subscription' })

 Usage:

 dataLayer.track('checkout', { type: 'subscription' })
 dataLayer.push({ type: 'subscription' })

 */

const windowEntity = 'dataLayer'

const methods = {
  push: true,
  track: true,
}

const dataLayer = new WindowResolver({
  name: windowEntity,
  methods,
  resolver: () => Boolean(window.dataLayer),
  eventHandler: (methodName, ...args) => {
    let params

    if (methodName === 'track') {
      const [ event, eventParams ] = args

      params = { event, ...eventParams }
    }
    else {
      params = args[0]
    }

    window.dataLayer.push(params)
  },
  modifyTestAnalyticsArgs: (methodName, ...args) => {
    let modifiedArgs

    if (methodName === 'track') {
      const [ event, eventParams ] = args

      modifiedArgs = { event, ...eventParams }
    }
    else {
      modifiedArgs = args[0]
    }

    return [ modifiedArgs ]
  },
}) as unknown as DataLayer


export default dataLayer

export {
  windowEntity,
  methods,
}
